import React, { useState } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
import { db, storage } from "../../../firestore-DB-config/firebase-config"; // Adjust the import path
import { collection, addDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Header from "../../../components/Header/Header";
import Footer from "../../../components/Footer/Footer";

const AddTeamMemberForm: React.FC = () => {
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string | null>(null); // State for image preview

  const handleImageUpload = async (file: File) => {
    const storageRef = ref(storage, `teamMembers/${file.name}`);
    await uploadBytes(storageRef, file);
    const imageUrl = await getDownloadURL(storageRef);
    return imageUrl;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const imageUrl = image ? await handleImageUpload(image) : "";

      await addDoc(collection(db, "teamMembers"), {
        name,
        role,
        description,
        imageUrl,
      });

      // Reset the form
      setName("");
      setRole("");
      setDescription("");
      setImage(null);
      setImagePreview(null); // Reset image preview
    } catch (error) {
      console.error("Error adding team member: ", error);
    }
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;
    setImage(file);

    if (file) {
      const previewUrl = URL.createObjectURL(file); // Create a preview URL for the selected file
      setImagePreview(previewUrl);
    } else {
      setImagePreview(null); // Reset preview if no file is selected
    }
  };

  return (
    <>
      <Header />
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{ maxWidth: "500px", mx: "auto", p: 4, my: 6 }}
      >
        <Typography variant="h6" mb={2}>
          Add Team Member
        </Typography>
        <TextField
          fullWidth
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          margin="normal"
        />
        <TextField
          fullWidth
          label="Role"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          required
          margin="normal"
        />
        <TextField
          fullWidth
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
          margin="normal"
          multiline
          rows={4}
        />
        <Button variant="outlined" component="label" fullWidth sx={{ mt: 2 }}>
          Upload Image
          <input
            type="file"
            hidden
            onChange={handleImageChange} // Use the new function
          />
        </Button>
       
        {/* Show image preview if available */}
        {imagePreview && (
          <Box
            display="flex"
            justifyContent="center"
            mt={2} // margin-top
          >
            <Box
              component="img"
              src={imagePreview}
              alt="Image Preview"
              sx={{
                width: "35%",
                height: "auto",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
          </Box>
        )}

        <Button type="submit" variant="contained" fullWidth sx={{ mt: 4 }}>
          Add Team Member
        </Button>
      </Box>
      <Footer />
    </>
  );
};

export default AddTeamMemberForm;
